export const WHITE_HEX_OPACITY_0 = '#00000000';
